import React, { useState, useEffect, useContext, useRef } from 'react';
import styled from 'styled-components';
import LoginForm from './LoginForm';
import { useLocation, useHistory } from 'react-router-dom';

import queryString from 'query-string';

import { Context as UserContext } from '../../context/UserContext';

import expoHallAPI from '../../api/expoHallAPI';
import { Context as AttendantContext } from '../../context/AttendantContext';
import SiteData from '../../config';

const RegistrationForm = ({ className }) => {
  const location = useLocation();
  const history = useHistory();

  const {
    state: { user },
    setUser,
  } = useContext(UserContext);
  const {
    state: { attendant },
    setAttendant,
  } = useContext(AttendantContext);

  const [alreadyExist, setalreadyExist] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    setEmail(queryString.parse(location.search).email);
  }, []);

  useEffect(() => {
    authenticateUser();
  }, []);

  const authenticateUser = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-user');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendee/profile/');
      // console.log(data);
      if (data) {
        setUser(data);
        history.push('/');
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-user');
      setUser(undefined);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const { data } = await expoHallAPI.post('/login/', {
        email: email.toLowerCase(),
        password,
        schema: SiteData.schemaName,
      });
      if (data) {
        if (data.is_attendant == 'True') {
          localStorage.setItem('shrm-li-expo-attendant', data.token);
          expoHallAPI.defaults.headers.common['Authorization'] =
            'Bearer ' + data.token;
          if (data.tile === true) {
            history.push('/dashboard');
          } else if (data.tile === false) {
            history.push('/');
          }
        }
        if (data.is_attendee == 'True') {
          localStorage.setItem('shrm-li-expo-user', data.token);
          expoHallAPI.defaults.headers.common['Authorization'] =
            'Bearer ' + data.token;
          history.push('/');
        }
      }
    } catch (error) {
      console.log(error.response);
      if (error.response) {
        if (error.response.status === 500) {
          history.push('/register', { email: email, password: password });
        }
        if (error.response.status === 403) {
          setalreadyExist(true);
        }
      }
    }
  };

  return (
    <div className={className}>
      <LoginForm
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        handleSubmit={handleSubmit}
        setalreadyExist={setalreadyExist}
        alreadyExist={alreadyExist}
      />
    </div>
  );
};

export default styled(RegistrationForm)``;
